import { statusSort, weekSort, defaultSort } from '../../../../Utils/Table'
import { authorization } from 'Module/Auth/Auth'

/**
 * Headers
 */
export const tableHeaders = [
  'Select',
  'Label',
  'Density',
  'Addresses',
  'Flyer Code',
  authorization.isClientAdmin() ? null : 'Pack Size',
  'Flyers Distributed',
  'Week',
  'Date',
  'Pay Adjustment',
  'Cost Per Flyer',
  'Status',
  'BA',
  'Actions',
]

/**
 * Columns that will be sortable
 */
export const sortableColumns = [
  'Density',
  'Addresses',
  { label: 'Week', sort: weekSort },
  { label: 'Status', sort: statusSort },
  { label: 'Label', sort: defaultSort },
  { label: 'BA', sort: defaultSort },
  { label: 'Pay Adjustment', sort: defaultSort },
  { label: 'Cost Per Flyer', sort: defaultSort },
  { label: 'Pack Size', sort: defaultSort },
  { label: 'Flyers Distributed', sort: defaultSort },
  { label: 'Date', sort: defaultSort },
]

/**
 * Filters will be created for those columns
 */
export const filterableColumns = [
  { label: 'Status', sort: statusSort },
  { label: 'Week', sort: weekSort, sorted: false },
]



// WEBPACK FOOTER //
// ./src/Containers/LetterboxMissions/blocks/LetterboxMissionsTable/settings.js